import Settings from 'common/helpers/settings/.'

class CASHelper {
  static redirectToCASLogin = () => {
    const url = `${Settings.app.sso}/login?service=${location.href}&systemOrigin=app-live-user`

    location.href = url
  }
}

export default CASHelper
